import {
  withLeadingSlash,
  withoutLeadingSlash,
  withoutTrailingSlash
} from "@studiometa/js-toolkit/utils";
import { Figure, loadImage } from "./Figure.js";
function normalizeSize(that, prop) {
  const { step } = that.$options;
  return Math.ceil(that.$refs.img[prop] / step) * step;
}
const isBot = /bot|crawl|slurp|spider/i.test(navigator.userAgent);
class FigureTwicpics extends Figure {
  /**
   * Config.
   */
  static config = {
    ...Figure.config,
    name: "FigureTwicpics",
    options: {
      ...Figure.config.options,
      transform: String,
      domain: String,
      path: String,
      disable: Boolean,
      step: {
        type: Number,
        default: 50
      },
      mode: {
        type: String,
        default: "cover"
      },
      dpr: {
        type: Boolean,
        default: true
      }
    }
  };
  /**
   * Get the Twicpics path.
   */
  get path() {
    return withoutTrailingSlash(withoutLeadingSlash(this.$options.path));
  }
  /**
   * Get the Twicpics domain.
   */
  get domain() {
    const url = new URL(this.$refs.img.dataset.src);
    return url.host;
  }
  /**
   * Get formatted original source.
   * If `disable` option is `true` returns the original src.
   */
  get original() {
    return this.$options.disable ? super.original : this.formatSrc(super.original);
  }
  /**
   * Get the current device pixel ratio
   * Returns 1 if user agent is considered as a bot.
   * Returns 1 if disabled by the `data-option-no-dpr` attribute.
   */
  get devicePixelRatio() {
    if (!this.$options.dpr || isBot) {
      return 1;
    }
    return window.devicePixelRatio;
  }
  /**
   * Format the source for Twicpics.
   */
  formatSrc(src) {
    const url = new URL(src, "https://localhost");
    url.host = this.domain;
    url.port = "";
    if (this.path && !url.pathname.startsWith(withLeadingSlash(this.path))) {
      url.pathname = `/${this.path}${url.pathname}`;
    }
    const width = normalizeSize(this, "offsetWidth") * this.devicePixelRatio;
    const height = normalizeSize(this, "offsetHeight") * this.devicePixelRatio;
    url.searchParams.set(
      "twic",
      ["v1", this.$options.transform, `${this.$options.mode}=${width}x${height}`].filter(Boolean).join("/")
    );
    url.search = decodeURIComponent(url.search);
    return url.toString();
  }
  /**
   * Reassign the source from the original on resize.
   */
  async resized() {
    const { src } = await loadImage(this.original);
    this.src = src;
  }
  /**
   * Do not terminate on image load as we need to set the src on resize.
   */
  onLoad() {
  }
}
export {
  FigureTwicpics
};
//# sourceMappingURL=FigureTwicpics.js.map
